import { METHOD, request } from '@/utils/request';
import { GET_CONTENT_SETTING } from './api';
export function GetContentSetting(identifierList) {
  return request(GET_CONTENT_SETTING, METHOD.POST, {
    identifierList,
  });
}
